/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { withAuthRedirect } from "@/shared/ui";

import { useAuth } from "@context/authentication";
import { useNavigate, useSearchParams } from 'react-router';
import { useEffect } from "react";
import { AgenciesService } from "@services/requests";
import { globalErrorType, useGlobalError } from "@context/ErrorContext";
import { appLayoutContext } from "@layout/app/LayoutContext";
import { jwtDecode } from "jwt-decode";
import { LoadingPage } from "@pages/other/LoadingPage";

type TokenPayload = {
  iss: string;
  sub: string;
  exp: number;
  agency_id: string;
  role: string;
  agency_name: string;
};

/**
 * AcceptInvitePage component.
 *
 * @returns {JSX.Element} React component element
 */
const AcceptInvitePage = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const { setGlobalError } = useGlobalError((state) => state);

  const { useStore } = appLayoutContext;
  const { updatePopupProps } = useStore((state) => state);

  useEffect(() => {
    if (token) {
      const decodedToken = jwtDecode<TokenPayload>(token);
      const agency_id = decodedToken.agency_id;

      AgenciesService.acceptAgencyInvite(agency_id, token)
        .then(() => navigate(`/app/agencies/${agency_id}`))
        .catch((e) => {
          const error = e as globalErrorType;
          console.log(error);
          if (error?.status != 404)
            setGlobalError(error, navigate, updatePopupProps);
          else {
            auth.signout();
          }
        });
    }
  }, []);

  if (!token) navigate("/app/workspace");
  else return <LoadingPage />;
};

export default withAuthRedirect(AcceptInvitePage);
